<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { resetPassword } from '../scripts/apiUsers';
    import { storeLoader, storeLanguage, lang_fr } from "../scripts/store";
    import { launchLoader, stopLoader } from "../scripts/utils";
    import { eraseCookie } from "../scripts/utils";
    import { storeIsLogin } from "../scripts/user";

    let email: string = "";

    onMount(async () => {
        window.scrollTo(0,0);
	});

    function procedureResetPassword() {
        launchLoader();
        const returnValue = resetPassword(email);
        eraseCookie("cat-login");
        storeIsLogin.set(false);
        returnValue.then((data) => {
            stopLoader();
        });
    }

</script>
    
<style lang="scss">

    .resetpassword {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        margin: 0 0 40px 0;
        &__bloc {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: 0 0 40px 0;
        }
        &__input {
            margin: 40px 0 0 0;
        }
        &__registration {
            color: $color_primary;
        }
    }

    @include large {
        .resetpassword {
            &__registration {
                cursor: pointer;
                &:hover {
                    color: $color_orange;
                }
            }
        }
    }

</style>

<div class="resetpassword">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="Réinitialisation du mot de passe"/>
    {:else}
    <PageHeader props="Reset password"/>
    {/if}
    {#if ($storeLanguage == $lang_fr)}
    <form class="bloc resetpassword__bloc">
        <input class="resetpassword__input font" type="text" name="email" placeholder="adresse mail" bind:value={email}>
    </form>
    <input class="button" type="submit" on:click={procedureResetPassword} value="Demande de réinitialisation">
    {:else}
    <form class="bloc resetpassword__bloc">
        <input class="resetpassword__input font" type="text" name="email" placeholder="email adress" bind:value={email}>
    </form>
    <input class="button" type="submit" on:click={procedureResetPassword} value="Reset">
    {/if}
</div>
